// extracted by mini-css-extract-plugin
export default {"description":"NewsItem_description__GXX7r","expanded":"NewsItem_expanded__-FEZ5","news__image":"NewsItem_news__image__wh+9Q"};